import _ from 'lodash';
import React from 'react';
import {
  FilledInput,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  OutlinedInput,
  MenuItem,
} from '@mui/material';

import Select, { SelectChangeEvent } from '@mui/material/Select';

import { withFormsy } from 'formsy-react';
import { pick } from 'lodash';

function MultipleSelectFormsy(props) {
  const importedProps = pick(props, [
    'autoWidth',
    'children',
    'classes',
    'displayEmpty',
    'input',
    'inputProps',
    'MenuProps',
    'native',
    'onClose',
    'onOpen',
    'open',
    'renderValue',
    'SelectDisplayProps',
    'variant',
    'color',
    'required',
  ]);

  // An error message is returned only if the component is invalid
  const { options, errorMessage, description, value } = props;

  function input() {
    switch (importedProps.variant) {
      case 'outlined':
        return <OutlinedInput label={props.label} id={props.name} />;
      case 'filled':
        return <FilledInput id={props.name} />;
      default:
        return <Input id={props.name} />;
    }
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    console.log(value);
    const selected = typeof value === 'string' ? value.split(',') : value;
    props.setValue(selected);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  const helperText = errorMessage || description;
  return (
    <FormControl
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      className={props.className}
      variant={importedProps.variant}
      disabled={props.disabled}
    >
      {props.label && <InputLabel id={`${props.name}-label`}>{props.label}</InputLabel>}
      <Select
        {...importedProps}
        labelId={`${props.name}-label`}
        value={value || []}
        onChange={handleChange}
        input={input()}
        multiple
      >
        {(options || []).map((option) => (
          <MenuItem value={option} key={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default React.memo(withFormsy(MultipleSelectFormsy));
